<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Cores">
          <listar-cor />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListarCor from '@/components/administrativo/veiculo/cor/ListarCor'
export default {
  data() {
    return {
      page: {
        title: 'Gerenciamento de cores',
      },
      breadcrumbs: [
        {
          text: 'Sistema',
          disabled: true,
        },
        {
          text: 'Cores',
          disabled: false,
        },
      ],
    }
  },
  components: {
    ListarCor,
  },
}
</script>

<style></style>
